import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useToast } from '@/components/_common/Toast';
import { useDownload } from '@/hooks/useDownload';
import axios from '@/_utils/axios';
import { PolarisIcon } from '@/exports/columnCommonComponents';

interface Props {
  reportId: number;
}

const DownloadReportButton: React.FC<Props> = ({ reportId }) => {
  const { error } = useToast();
  const { download } = useDownload();
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);

  const handleDownloadButtonClick = () => {
    setIsLoading(true);

    axios
      .get(`/focus/reports/${reportId}/`)
      .then(({ data }) => {
        const url = data?.data?.download_url;
        const fileName = data?.data?.name || 'report.xlsx';
        if (!url) throw new Error('Missing `download_url`');
        download({ url, fileName });
        setIsDownloaded(true);
      })
      .catch((res) => {
        error(`Failed to download report${res?.data?.message ? `: ${res?.data?.message}` : ''}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const buttonText = isLoading ? 'Downloading...' : isDownloaded ? 'Download again' : 'Download';

  return (
    <Button disabled={isLoading} variant="contained" sx={{ pl: 1 }} onClick={handleDownloadButtonClick}>
      <PolarisIcon icon="download" height={18} style={{ marginRight: 8 }} />
      {buttonText}
    </Button>
  );
};

export default DownloadReportButton;
